<template>
  <div>
    <PageAllow controller="Requisitions" action="getIntelligentDetails" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card v-show="!preview">
        <v-card-title class="mx-3">
          {{ $t("AutoRequisition.title") }}
          <v-spacer />
          <v-btn
            v-if="$permission.permissionAllow('Requisitions', 'addViews')"
            small
            :disabled="!doPreviewFlg"
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doPreview()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("AutoRequisition.actions.addView") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <ValidationObserver ref="observer">
          <div v-for="(requisition, index) in requisitions" :key="index">
            <v-data-table
              :headers="detailsHeaders"
              :items="requisition.requestion_details"
              disable-sort
              class="elevation-2 px-4 mt-5"
              disable-pagination
              hide-default-footer
              v-if="requisition.requestion_details.length"
            >
              <template v-slot:top>
                <v-toolbar flat class="transparent-background-color">
                  {{ $t("Requisition.Fields.stock_requisition_out") }}
                  {{ $t("Global.colon") }}
                  <span v-if="!requisition.setStockFlg">
                    {{ requisition.stock_from.code + ' / ' + requisition.stock_from.name }}
                  </span>
                  <span v-else>
                    <SearcherStock v-model="requisition.stock_from" :stock-types="[0]" style="margin-top: 20px" />
                  </span>
                </v-toolbar>
                <v-divider />
                <v-toolbar flat class="transparent-background-color">
                  {{ $t("Requisition.Fields.stock_requisition_in") }}
                  {{ $t("Global.colon") }}
                  {{ requisition.stock_to.code + ' / ' + requisition.stock_to.name }}
                </v-toolbar>
                <v-divider />
              </template>
              <template v-slot:item.Description="{ item }">
                <a
                  class="text-no-wrap"
                  :class="item.error_flg ? 'red--text' : ''"
                  @click.stop="
                    dialogMaterialID = item.material_id
                  "
                >
                  {{ $t(
                    settings
                    ? settings.material_name_display_type == 4
                      ? "Material.nameWithCodeAndStandard"
                      : settings.material_name_display_type == 3
                      ? "Material.materialNameWithCodeAndStandard"
                        : settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                      : "Material.materialName"
                    : "Material.materialName",
                    [
                  item.material_code,
                  item.material_name,
                  item.standard_name,
                    ]
                  ) }}
                </a>
              </template>
              <template v-slot:item.unit="{ item }">
                <v-autocomplete
                  v-model="item.standard_detail_id"
                  :items="item.standard_details"
                  item-text="unit"
                  item-value="id"
                  unclearable
                  style="width: 20px"
                />
              </template>
              <template v-slot:item.order_num="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Requisition.DetailFields.requisition_num')"
                  rules="required"
                >
                  <NumberInput
                    v-model="item.order_num"
                    :error-messages="errors"
                    class="ml-0"
                    dense
                  />
                </ValidationProvider>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  small
                  text
                  class="danger--text pa-0"
                  @click.stop="
                    requisition.requestion_details.splice(
                      requisition.requestion_details.findIndex((detail) => item.material_id == detail.material_id),
                      1
                    )
                  "
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </ValidationObserver>
      </v-card>
      <v-card v-show="preview">
        <v-card-title class="mx-3">
          {{ $t("AutoRequisition.title") }}
          <v-spacer />
          <v-btn
            small
            outlined
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="preview = false;"
          >
            {{ $t("CRUD.back") }}
          </v-btn>
          <v-btn
            v-if="$permission.permissionAllow('Requisitions', 'addViews')"
            small
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doPreview()"
          >
            {{ $t("AutoRequisition.actions.reload") }}
          </v-btn>
          <v-btn
            v-if="$permission.permissionAllow('Requisitions', 'add')"
            small
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doSubmit()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("AutoRequisition.actions.confirm") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <div v-if="noStockRequisitionDetails.length > 0">
          <v-data-table
            :headers="noStockRequisitionHeaders"
            :items="noStockRequisitionDetails"
            disable-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                {{ $t("AutoRequisition.Fields.missMaterials") }}
              </v-toolbar>
              <v-divider />
            </template>
            <template v-slot:item.Description="{ item }">
              <a
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
                @click.stop="
                  dialogMaterialID = item.material.material_id
                "
              >
                {{ $t(
                  settings
                  ? settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                      : settings.material_name_display_type == 2
                      ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                  [
                    item.material.material_code,
                    item.material.material_name,
                    item.material.standard_name,
                  ]
                ) }}
              </a>
            </template>
          </v-data-table>
        </div>
        <div v-for="(requisition, index) in requisitionsPreview" :key="index">
          <v-data-table
            :headers="previewHeaders"
            :items="requisition.requisition_details"
            disable-sort
            class="elevation-2 px-4 mt-5"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                {{ $t("Requisition.Fields.stock_requisition_out") }}
                {{ $t("Global.colon") }}
                {{ requisition.requisition_from.code + ' / ' + requisition.requisition_from.name }}
              </v-toolbar>
              <v-divider />
              <v-toolbar flat class="transparent-background-color">
                {{ $t("Requisition.Fields.stock_requisition_in") }}
                {{ $t("Global.colon") }}
                {{ requisition.requisition_to.code + ' / ' + requisition.requisition_to.name }}
              </v-toolbar>
              <v-divider />
            </template>
            <template v-slot:item.unit="{ item }">
              {{ (item.standard_detail[item.standard_detail_id]) ? item.standard_detail[item.standard_detail_id].unit : "" }}
            </template>
            <template v-slot:item.Description="{ item }">
              <a
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
                @click.stop="
                  dialogMaterialID = item.material.id
                "
              >
                {{ $t(
                  settings
                  ? settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                      : settings.material_name_display_type == 2
                      ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                  [
                    item.material.material_code,
                    item.material.material_name,
                    item.material.standard_name,
                  ]
                ) }}
              </a>
            </template>
            <template v-slot:item.from_stock_material="{ item }">
               <span
                class="text-no-wrap caption secondary--text"
                :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
               >
                {{ $t("Requisition.DetailFields.unrequisition") }}
                {{ $t("Global.colon") }}
                {{ $numberFormatter.formatTwoDot(item.from_stock_material.current_count, true) }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
              >
                {{ $t("Requisition.DetailFields.requisitioned") }}
                {{ $t("Global.colon") }}
                <span class="red--text">
                  {{ $numberFormatter.formatTwoDot(item.from_stock_material.current_count - item.order_num, true) }}
                </span>
              </span>
            </template>
            <template v-slot:item.to_stock_material="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
              >
                {{ $t("Requisition.DetailFields.unrequisition") }}
                {{ $t("Global.colon") }}
                {{ $numberFormatter.formatTwoDot(item.to_stock_material.current_count, true) }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
              >
                {{ $t("Requisition.DetailFields.requisitioned") }}
                {{ $t("Global.colon") }}
                <span class="red--text">
                  {{ $numberFormatter.formatTwoDot(item.to_stock_material.current_count + item.order_num, true) }}
                </span>
              </span>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-sheet>
    <MaterialDialog v-model="dialogMaterialID" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Requisitions from "@/api/requisitions";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import SearcherStock from "@/components/plugins/SearcherStock";
import NumberInput from "@/components/plugins/NumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    MaterialDialog,
    SearcherStock,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.requisitions"),
          disabled: false,
          href: "/requisitions",
        },
        {
          text: i18n.t("AutoRequisition.title"),
          disabled: false,
          href: "/requisitions/auto-requisition",
        },
        {
          text: i18n.t("AutoRequisition.create.title"),
          disabled: true,
          href: "/requisitions/auto-requisition-create",
        },
      ];
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Requisition.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Requisition.DetailFields.material_name"),
          align: "start",
          width: "500px",
          value: "Description",
        },
        {
          text: i18n.t("Requisition.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("Requisition.DetailFields.order_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      ];
      return headers;
    },
    noStockRequisitionHeaders() {
      return [
        {
          text: i18n.t("Requisition.DetailFields.material_name"),
          align: "start",
          width: "500px",
          value: "Description",
        },
        {
          text: i18n.t("Requisition.DetailFields.unit"),
          align: "start",
          value: "material.unit_order",
        },
        {
          text: i18n.t("Requisition.DetailFields.order_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("Requisition.DetailFields.stock_requisition_out_name"),
          align: "start",
          value: "requisition_from.name",
        },
        {
          text: i18n.t("Requisition.DetailFields.stock_requisition_in_name"),
          align: "start",
          value: "requisition_to.name",
        },
      ];
    },
    previewHeaders() {
      return [
        {
          text: i18n.t("Requisition.DetailFields.material_name"),
          align: "start",
          width: "500px",
          value: "Description",
        },
        {
          text: i18n.t("Requisition.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("Requisition.DetailFields.order_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("Requisition.DetailFields.stock_requisition_out_num_count"),
          align: "end",
          value: "from_stock_material",
        },
        {
          text: i18n.t("Requisition.DetailFields.stock_requisition_in_num_count"),
          align: "end",
          value: "to_stock_material",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    requisitions: [],
    preview: false,
    doPreviewFlg: false,
    dialogMaterialID: null,
    noStockRequisitionDetails: [],
    requisitionsPreview: [],

  }),

  mounted() {
    this.getIntelligentDetails();
  },

  methods: {
    getIntelligentDetails() {
      let data = {};
      data = Object.assign({}, data, {
        stock_order_ids: this.$route.query.stockOrderIds,
      });
      Requisitions.getIntelligentDetails(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.requisitions = response.data.requestions.map((item) => {
              if (item.stock_from.length == 0) {
                item.stock_from = {};
                item.setStockFlg = true;
              }else {
                item.setStockFlg = false;
              }
              return item
            });
            this.doPreviewFlg = true;
          }
        }.bind(this)
      );
    },
    //整理预览提交数据
    doPreviewData() {
      let requisitions = [];
      this.requisitions.forEach((item) => {
        if (item.requestion_details.length) {
          let data = {
            requisition_from: item.stock_from.id,
            requisition_to: item.stock_to.id,
            requisition_details: [],
          };

          item.requestion_details.forEach((detail) => {
            data.requisition_details.push({
              material_code: detail.material_code,
              standard_detail_id: detail.standard_detail_id,
              order_num: detail.order_num,
              detail_ids: detail.detail_ids
            });
          });
          requisitions.push(data);
        }
      });
      return requisitions;
    },
    //添加预览
    doPreview() {
      let data = this.doPreviewData();
      Requisitions.addViews(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.noStockRequisitionDetails = response.data.no_stock_requisition_details;
            this.requisitionsPreview = response.data.requisitions;
            this.preview = true;
          }
        }.bind(this)
      );
    },
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      let submitData = this.requisitionsPreview.map((p) => {
        if (p.requisition_details) {
          let data = {
            requisition_from: p.requisition_from.id,
            requisition_to: p.requisition_to.id,
            requisition_details: [],
          };

          p.requisition_details.forEach((detail) => {
            data.requisition_details.push({
              detail_ids: detail.detail_ids,
              material_code: detail.material_code,
              standard_detail_id: detail.standard_detail_id,
              order_num: detail.order_num,
            });
          });
          return data;
        }else {
          return [];
        }
      });
      let dateNull = null;
      if (submitData.length) {
        submitData.forEach((d) => {
          if (!d.requisition_details) {
            dateNull += 1;
          }
        });
      }

      if (dateNull) {
        this.$snackbar.error(i18n.t("AutoRequisition.Messages.detailsNull"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else {
        Requisitions.add(submitData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/requisitions");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
  },

  watch: {},
};
</script>